import { Nullable } from 'common-types';

export enum NotificationError {
  FailedLoadNotificationSettings = 'Failed to load notification settings, please try again later',
}

export enum ButtonTooltip {
  ReadOnlyNotAllowedForAction = 'Read only user cannot perform this action',
  PleaseEnableOrgNotifications = 'Please enable org notification to perform this action',
  SendTestEmail = 'Send a test email to my personal email account',
  DisableOrgNotifications = 'Click to disable organization notifications',
  EnableOrgNotifications = 'Click to enable all organization notifications',
  DisableUserNotifications = 'Click to disable notifications for my user only',
  EnableUserNotifications = 'Click to enable notifications for my user',
  EnableLimitMemberNotification = 'Click to enable specific user notifications',
  DisableLimitMemberNotification = 'Click to disable specific user notifications',
  AllOrgMembersAreNotified = 'All org members are already notified',
}

export interface NotificationSettings {
  notificationChannelType: NotificationChannelType;
  recipients: Nullable<Recipient[]>;
  notifyAll: boolean;
  enabled: boolean;
  isUserUnsubscribed: boolean;
}

export enum NotificationChannelType {
  Email = 'Email',
}

export enum NotificationType {
  TestNotification = 'TestNotification',
}

export interface Recipient {
  user_id: string;
  name: string;
  email: string;
}
